module.exports = __webpack_public_path__ + "static/media/eve-bunny.2e50917e.svg";